import { useTranslations } from '@react/lib/i18n';
import * as React from 'react';
import { FormDefinitionsContainer } from './FormDefinitionsPage.styled';
var FormDefinitionsPage = function (_a) {
    var clinicToken = _a.clinicToken, language = _a.language, formDesignerLoaded = _a.formDesignerLoaded;
    var t = useTranslations().t;
    if (!formDesignerLoaded) {
        return (React.createElement(FormDefinitionsContainer, null, t.Admin.FormsLoadingMessage || 'Loading forms...'));
    }
    return (React.createElement(FormDefinitionsContainer, null, React.createElement('salve-clinic-form-designer', {
        'clinic-token': clinicToken,
        language: language
    })));
};
var ɵ0 = FormDefinitionsPage;
export default FormDefinitionsPage;
export { ɵ0 };
